import * as React from "react"
import { Loader2, AlertTriangle, Inbox, RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"

export function PageLoader({ message = "Loading..." }) {
  return (
    <div className="flex items-center justify-center min-h-[300px]">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto mb-3" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  )
}

export function EmptyState({ title = "No data", description = "There is nothing to display yet.", icon: Icon = Inbox, action }) {
  return (
    <div className="flex items-center justify-center min-h-[300px]">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center">
          <Icon className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground mb-4">{description}</p>
          {action && (
            <Button variant="outline" size="sm" onClick={action.onClick}>
              {action.label}
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export function ErrorState({ title = "Something went wrong", message, onRetry }) {
  return (
    <div className="flex items-center justify-center min-h-[300px]">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center">
          <AlertTriangle className="h-12 w-12 text-destructive mx-auto mb-4" />
          <h3 className="text-lg font-medium mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground mb-4">
            {message || "An error occurred while loading data."}
          </p>
          {onRetry && (
            <Button variant="outline" size="sm" onClick={onRetry}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Try Again
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
